module.exports = __webpack_public_path__ + "img/qu_kr.1fea565.jpg";